import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  order?: { affair_otp?: number | string };
};

const AffairOtpCell = React.memo((row: KpiWorkunitGridData) => {
  const affair = row.order?.affair_otp ? String(row.order.affair_otp).trim() : '';
  return (
    <Tooltip title={affair}>
      <Typography variant="body2" noWrap>
        {affair}
      </Typography>
    </Tooltip>
  );
});

export default AffairOtpCell;
